<div class="backModal enCierre">
  <div class="close closeModal">
    <a (click)="close()" title="cerrar"
      ><span class="cross"></span><span class="sr-only">cerrar</span></a
    >
  </div>
  <div class="aviso" id="tabs-content-gestion">
    <div class="tituloSearch">{{ 'CIERRE_DE_CAJA' | translateV2 }}</div>
    <div class="avisoInputWrap" [formGroup]="cierreTurno">
      <div class="form-group">
        <div class="tit-form-group">
          <label for="cierreEfectivo">{{ 'EFECTIVO' | translateV2 }}</label>
        </div>
        <input
          type="text"
          #cambioEfectivo
          category="DIVISA"
          formControlName="efectivo"
          #efectivo
          class="form-control efectivo"
          [ngClass]="{ 'active-form': isSelected(cambioEfectivo) }"
          id="cierreEfectivo"
          [placeholder]="placeholderValue"
          (focus)="focusValue($event)"
        />
      </div>
      <!-- <div class="form-group bolsaCambio">
        <div class="tit-form-group">
          <label for="bolsaDeCambio">BOLSA DE CAMBIO</label>
        </div>
        <input type="text" #cambioBolsa formControlName="bolsaCambio" category="BOLSACAMBIO" class="form-control" [ngClass]="{'active-form' : isSelected(cambioBolsa)}" id="bolsaDeCambio" placeholder="abc01234" (focus)="focusValue($event)">
      </div> -->
      <div class="form-group textarea">
        <div class="tit-form-group">
          <label for="comentarios">{{ 'COMENTARIOS' | translateV2 }}</label>
        </div>
        <textarea
          formControlName="comentario"
          #comentario
          (focus)="focusValue($event)"
          category="TEXTAREA"
          class="form-control"
          rows="2"
          cols="40"
          id="comentarios"
          [ngClass]="{ 'active-form': isSelected(comentario) }"
        ></textarea>
      </div>
    </div>
    <div class="faturacion-fila">
      <div class="ticket-info">
        <div class="inputControl botones">
          <button
            type="button"
            value="cancelar"
            class="cancelar"
            (click)="close()"
          >
            {{ 'CANCELAR' | translateV2 }}
          </button>
        </div>
      </div>
      <div class="ticket-info">
        <div class="inputControl botones">
          <button
            type="button"
            value="ACEPTAR"
            [ngClass]="{ disabled: checkFormIsInvalid() }"
            class="pagar aceptar"
            (click)="cerrarTurno()"
          >
            {{ 'ACEPTAR' | translateV2 }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="keyboardWrap">
    <ticketing-keyboard></ticketing-keyboard>
    <ticketing-numpad></ticketing-numpad>
  </div>
</div>

<ng-container>
  <body [hidden]="true" *ngIf="datosInforme">
    <div id="my-div0">
      {{ 'DESGLOSE_VENTAS' | translateV2 }}
      <hr />
      {{ calculaFecha(datosInforme.FechaInicio) }}
      {{ calculaHora(datosInforme.FechaCierre) }}
      <br />
      Nº {{ 'CAJA' | translateV2 }} {{ datosInforme.CajaId }}
      <br />
      <div *ngFor="let usuario of usuarios">
        {{'USUARIO' | translateV2}} {{ usuario.UsuarioId }} {{ usuario.UsuarioNombre }}
      </div>
      {{ 'JUSTIFICANTE_TPV' | translateV2 }} {{ datosInforme.TPVId }} {{ datosInforme.TPVNombre }}
    </div>

    <table id="my-table1">
      <thead>
        <tr>
          <th>{{ 'DATOS_IDENTIFICATIVOS' | translateV2 }}</th>
        </tr>
      </thead>
    </table>
    <table id="my-table2">
      <tbody>
        <tr>
          <th>{{'NOMBRE_TPV' | translateV2 }}:</th>
          <td>{{ datosInforme.TPVNombre }}</td>
        </tr>
        <tr>
          <th>{{ 'FECHA' | translateV2 }}:</th>
          <td>{{ calculaFecha(datosInforme.FechaInicio) }}</td>
        </tr>
        <tr>
          <th>{{ 'HORA_INICIO_CAJA' | translateV2 }}:</th>
          <td>{{ calculaHora(datosInforme.FechaInicio) }}</td>
        </tr>
        <tr>
          <th>{{ 'HORA_CIERRE_CAJA' | translateV2 }}:</th>
          <td>{{ calculaHora(datosInforme.FechaCierre) }}</td>
        </tr>
      </tbody>
    </table>
    <table id="my-table3">
      <thead>
        <tr>
          <th>{{ 'NOMBRE_USUARIO' | translateV2 }}</th>
          <th>{{ 'HORA_INICIO_SESION' | translateV2 }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr *ngFor="let usuario of usuarios">
            <td>{{ usuario.UsuarioNombre }}</td>
            <td>{{ calculaHora(usuario.FechaHoraInicio) }}</td>
          </tr>
        </ng-container>
        <ng-container *ngIf="usuarios.length < 3">
          <tr>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <table id="my-table4">
      <thead>
        <tr>
          <th>{{ 'DATOS_PRODUCTOS' | translate }}</th>
        </tr>
      </thead>
    </table>
    <table id="my-table5">
      <thead>
        <tr>
          <th>{{ 'ENTRADAS' | translate }}</th>
        </tr>
      </thead>
    </table>
    <table id="my-table6">
      <tbody>
        <tr>
          <td>{{ 'CONFIGURACION_PRODUCTO' | translate }}</td>
          <td>{{ 'VENTA' | translate }}</td>
          <td>{{ 'RESERVA' | translate }}</td>
          <td>{{ 'DEVOLUCION' | translate }}</td>
          <td>{{ 'TOTAL' | translate }}</td>
          <td>{{ 'PRECIO_UNIDAD' | translate }}</td>
          <td>{{ 'PRECIO_TOTAL' | translate }}</td>
        </tr>
      </tbody>
    </table>
    <table id="my-table7">
      <tbody>
        <ng-container *ngFor="let produto of productosVenta">
          <tr>
            <td>{{ produto.ProductoNombre }}</td>
            <td>{{ produto.ProductoCantidad }}</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>{{calculaPrecioUnitario(produto.ProductoImporteTotal, produto.ProductoCantidad)}}</td>
            <td>{{produto.ProductoImporteTotal | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <table id="my-table8">
      <tbody>
        <tr>
          <td>{{ 'TOTAL_ENTRADAS' | translate }}</td>
          <td>{{ calculaTotalNumVentas() }}</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>{{calculaTotalImporteVentas()}}</td>
        </tr>
      </tbody>
    </table>
    <table id="my-table9" *ngIf="false">
      <thead>
        <tr>
          <th>{{ 'ACTIVIDADES' | translate }}</th>
        </tr>
      </thead>
    </table>
    <table id="my-table10" *ngIf="false">
      <tbody>
        <tr>
          <td>{{ 'CONFIGURACION_PRODUCTO' | translateV2 }}</td>
          <td>{{ 'VENTA' | translateV2 }}</td>
          <td>{{ 'RESERVA' | translateV2 }}</td>
          <td>{{ 'DEVOLUCION' | translateV2 }}</td>
          <td>{{ 'TOTAL' | translateV2 }}</td>
          <td>{{ 'PRECIO_UNIDAD' | translateV2 }}</td>
          <td>{{ 'PRECIO_TOTAL' | translateV2 }}</td>
        </tr>
      </tbody>
    </table>
    <table id="my-table11" *ngIf="false">
      <tbody>
        <tr>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
        </tr>
      </tbody>
    </table>
    <table id="my-table12" *ngIf="false">
      <tbody>
        <tr>
          <td>{{ 'TOTAL_ACTIVIDADES' | translateV2 }}</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
        </tr>
      </tbody>
    </table>
    <table id="my-table13" *ngIf="false">
      <thead>
        <tr>
          <th>{{ 'SERVICIOS' | translateV2 }}</th>
        </tr>
      </thead>
    </table>
    <table id="my-table14" *ngIf="false">
      <tbody>
        <tr>
          <td>{{ 'CONFIGURACION_PRODUCTO' | translateV2 }}</td>
          <td>{{ 'VENTA' | translateV2 }}</td>
          <td>{{ 'RESERVA' | translateV2 }}</td>
          <td>{{ 'DEVOLUCION' | translateV2 }}</td>
          <td>{{ 'TOTAL' | translateV2 }}</td>
          <td>{{ 'PRECIO_UNIDAD' | translateV2 }}</td>
          <td>{{ 'PRECIO_TOTAL' | translateV2 }}</td>
        </tr>
      </tbody>
    </table>
    <table id="my-table15" *ngIf="false">
      <tbody>
        <tr>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
        </tr>
      </tbody>
    </table>
    <table id="my-table16" *ngIf="false">
      <tbody>
        <tr>
          <td>{{ 'TOTAL_SERVICIOS' | translateV2 }}</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
        </tr>
      </tbody>
    </table>
    <table id="my-table17" *ngIf="false">
      <thead>
        <tr>
          <th>{{ 'OTROS' | translateV2 }}</th>
        </tr>
      </thead>
    </table>
    <table id="my-table18" *ngIf="false">
      <tbody>
        <tr>
          <td>{{ 'CONFIGURACION_PRODUCTO' | translateV2 }}</td>
          <td>{{ 'VENTA' | translateV2 }}</td>
          <td>{{ 'RESERVA' | translateV2 }}</td>
          <td>{{ 'DEVOLUCION' | translateV2 }}</td>
          <td>{{ 'TOTAL' | translateV2 }}</td>
          <td>{{ 'PRECIO_UNIDAD' | translateV2 }}</td>
          <td>{{ 'PRECIO_TOTAL' | translateV2 }}</td>
        </tr>
      </tbody>
    </table>
    <table id="my-table19" *ngIf="false">
      <tbody>
        <tr>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
        </tr>
      </tbody>
    </table>
    <table id="my-table20" *ngIf="false">
      <tbody>
        <tr>
          <td>{{ 'TOTAL_OTROS' | translateV2 }}</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
        </tr>
      </tbody>
    </table>
    <table id="my-table21" *ngIf="false">
      <tbody>
        <tr>
          <td>{{ 'TOTAL' | translateV2 }}</td>
          <td>{{ calculaTotalNumVentas() }}</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>{{ calculaTotalImporteVentas() }} €</td>
        </tr>
      </tbody>
    </table>
    <table id="my-table22">
      <thead>
        <tr>
          <th>{{ 'DATOS_CIERRE_CAJA' | translateV2}}</th>
        </tr>
      </thead>
    </table>
    <table id="my-table23">
      <tbody>
        <tr>
          <td>{{ 'TOTAL_VENTAS' | translateV2 }}</td>
          <td>{{datosInforme.ImporteTotal | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles}}</td>
        </tr>
        <tr>
          <td>{{ 'VALIDACIONES_VENTA_ONLINE' | translateV2 }}</td>
          <td>0 €</td>
        </tr>
        <tr>
          <td>{{ 'VENTAS_TRANSFERENCIA' | translateV2 }}</td>
          <td>{{datosInforme.ImporteTR | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}</td>
        </tr>
        <tr>
          <td>{{ 'VENTAS_TARJETA_BANCARIA' | translateV2 }}</td>
          <td>{{datosInforme.ImporteCC | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}</td>
        </tr>
        <tr>
          <td>{{ 'VENTAS_EFECTIVO' | translateV2 }}</td>
          <td>{{datosInforme.ImporteCA | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}</td>
        </tr>
        <tr>
          <td>{{ 'VENTAS_EFECTIVO_ARQUEO_MANUAL' | translateV2 }}</td>
          <td>{{datosInforme.ImporteSupervisor | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}</td>
        </tr>
        <tr>
          <td>{{ 'DIFERENCIA_CAJA_ARQUEO_MANUAL' | translateV2 }}</td>
          <td>{{datosInforme.Diferencia | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}</td>
        </tr>
      </tbody>
    </table>
    <table id="my-table24">
      <thead>
        <tr>
          <th>{{ 'COMENTARIOS' | translateV2 }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>{{ comentarios }}</th>
        </tr>
      </tbody>
    </table>
    <table id="my-table25">
      <tbody>
        <tr>
          <th>{{ 'FIRMA_USUARIO_CIERRE_CAJA' | translateV2 }}</th>
          <th>{{ 'FIRMA_COORDINADOR_SERVICIO' | translateV2 }}</th>
        </tr>
      </tbody>
    </table>
  </body>
</ng-container>
